import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { SubscriptionService } from "src/app/core/service/subscription.service";
import { ValidatesCertificateService } from "src/app/data/service/validates-certificate/validates-certificate.service";
import enUS from "./i18n/en-US.json";
import esES from "./i18n/es-ES.json";
import ptBR from "./i18n/pt-BR.json";

@Component({
    selector: "app-validates-certificate",
    templateUrl: "./validates-certificate.component.html",
    styleUrls: ["./validates-certificate.component.scss"]
})
export class ValidatesCertificateComponent {
    private id: string;
    public hasError = false;
    public token: string;
    public certificateUrl: string;

    constructor(
        private validatesCertificateService: ValidatesCertificateService,
        private translate: TranslateService,
        private route: ActivatedRoute,
        private subscriptionService: SubscriptionService
    ) {
        this.translate.setTranslation("pt-BR", ptBR, true);
        this.translate.setTranslation("es-ES", esES, true);
        this.translate.setTranslation("en-US", enUS, true);

        this.route.params.subscribe((data) => (this.id = String(data.id)));
    }

    validate(): void {
        this.validatesCertificateService
            .GetCertificationUrl(this.id, this.subscriptionService.currentSubscription.id, this.token)
            .subscribe(
                (res) => {
                    this.certificateUrl = res;
                    this.hasError = false;
                },
                () => (this.hasError = true)
            );
    }
}
